(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fluff-build-box-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const setup = () => {
      if (window.FluffBuildBox?.version === 'base-first-v3') return window.FluffBuildBox;

      const dialog = document.getElementById('FluffGlobalBuildBox');
      const dataElement = document.getElementById('FluffGlobalBuildBoxData');
      if (!dialog || !dataElement) return null;

      const data = JSON.parse(dataElement.textContent);
      const card = dialog.querySelector('.fluff-build-modal__card');
      const closeButton = dialog.querySelector('[data-fluff-close]');
      const body = dialog.querySelector('[data-bab-body]');
      const back = dialog.querySelector('[data-bab-back]');
      const backLabel = dialog.querySelector('[data-bab-back-label]');
      const next = dialog.querySelector('[data-bab-next]');
      const nextLabel = dialog.querySelector('[data-bab-next-label]');
      const nextArrow = dialog.querySelector('[data-bab-next-arrow]');
      const nextHelp = dialog.querySelector('[data-bab-next-help]');
      const nav = dialog.querySelector('.fluff-bab-nav');
      const progress = dialog.querySelector('.fluff-bab-steps');
      const error = dialog.querySelector('[data-bab-error]');

      data.flavours = (data.flavours || []).filter((flavour) => flavour?.id && Array.isArray(flavour.variants) && flavour.variants.length);
      data.addOns = Array.isArray(data.addOns) ? data.addOns : [];
      data.bases = Array.isArray(data.bases) ? data.bases : [];
      const showAddOns = Boolean(data.addOnsEnabled && data.addOns.length);
      const minimum = Math.max(1, Number(data.minimum || 6));
      const state = { step: 1, activeBase: null, groups: {}, popSize: 'large', addOnCounts: {}, detailId: null, detailScrollTop: 0, returnToReview: false, lastCountChange: null, transitioning: false };
      const motionAllowed = () => dialog.dataset.babMotion === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let openingMotionTimer = 0;
      let stepMotionTimer = 0;

      const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[character]);
      const money = (cents) => new Intl.NumberFormat(undefined, { style: 'currency', currency: data.currency || window.Shopify?.currency?.active || 'CAD', maximumFractionDigits: 2 }).format(Number(cents || 0) / 100);
      const normaliseBase = (value) => {
        const handle = String(value || '').toLowerCase();
        return data.bases.find((base) => handle.includes(base.id))?.id || null;
      };
      const baseById = (id) => data.bases.find((base) => base.id === id);
      const compatible = (flavour, baseId) => !flavour.base || flavour.base === baseId;
      const baseProducts = (baseId) => data.flavours.filter((flavour) => compatible(flavour, baseId));
      const groupCounts = (baseId) => state.groups[baseId] || {};
      const groupTotal = (baseId) => Object.values(groupCounts(baseId)).reduce((sum, count) => sum + Number(count || 0), 0);
      const startedBases = () => data.bases.filter((base) => groupTotal(base.id) > 0);
      const totalPieces = () => startedBases().reduce((sum, base) => sum + groupTotal(base.id), 0);
      const totalAddOns = () => Object.values(state.addOnCounts).reduce((sum, count) => sum + Number(count || 0), 0);
      const baseImage = (baseId) => baseProducts(baseId).find((flavour) => flavour.image)?.image || '';

      const selectedVariant = (flavour) => {
        if (flavour.variantMode !== 'size') return (flavour.variants || []).find((variant) => variant.available) || flavour.variants?.[0] || null;
        const sizeWord = state.popSize === 'small' ? 'small' : 'large';
        const matches = (flavour.variants || []).filter((variant) => {
          const labels = [variant.title, ...(variant.options || [])].join(' ').toLowerCase();
          if (new RegExp(`\\b${sizeWord}\\b`).test(labels)) return true;
          if (sizeWord === 'small') return /\\bsm\\b|1[.,]3\\s*(?:×|x|by)\\s*2\\b/.test(labels);
          return /\\blg\\b|\\b2\\s*(?:×|x|by)\\s*3\\b/.test(labels);
        });
        return matches.find((variant) => variant.available) || matches[0] || null;
      };
      const selectedAddOnVariant = (addOn) => (addOn.variants || []).find((variant) => variant.available) || addOn.variants?.[0] || null;
      const totalPrice = () => startedBases().reduce((sum, base) => sum + data.flavours.reduce((subtotal, flavour) => subtotal + Number(groupCounts(base.id)[flavour.id] || 0) * Number(selectedVariant(flavour)?.price || 0), 0), 0)
        + data.addOns.reduce((sum, addOn) => sum + Number(state.addOnCounts[addOn.id] || 0) * Number(selectedAddOnVariant(addOn)?.price || 0), 0);

      const clearOpeningMotion = () => { window.clearTimeout(openingMotionTimer); openingMotionTimer = 0; dialog.classList.remove('is-opening'); };
      const clearStepMotion = () => { window.clearTimeout(stepMotionTimer); stepMotionTimer = 0; body.classList.remove('fluff-bab-enter-next', 'fluff-bab-enter-back', 'fluff-bab-leave-next', 'fluff-bab-leave-back'); };
      const hideError = () => { error.hidden = true; error.textContent = ''; };
      const showError = (message) => { error.textContent = message; error.hidden = false; };

      const nextBlockReason = () => {
        if (!data.flavours.length) return 'Build a Box is temporarily unavailable because no eligible products were found.';
        if (state.step === 1 && !state.activeBase) return 'Choose a marshmallow base to continue.';
        if (state.step === 2) {
          const count = groupTotal(state.activeBase);
          if (count < minimum) return `Add ${minimum - count} more ${minimum - count === 1 ? 'treat' : 'treats'} to this base group.`;
        }
        return '';
      };

      const syncProgress = () => {
        const visibleStep = state.step;
        progress.style.setProperty('--fluff-bab-progress', String((visibleStep - 1) / 3));
        progress.querySelectorAll('[data-bab-step]').forEach((step) => {
          const number = Number(step.dataset.babStep);
          const canNavigate = number < visibleStep && (number !== 3 || showAddOns);
          step.classList.toggle('is-active', number === visibleStep);
          step.classList.toggle('is-done', number < visibleStep);
          step.disabled = !canNavigate;
          step.setAttribute('aria-current', number === visibleStep ? 'step' : 'false');
          step.setAttribute('aria-label', canNavigate ? `Go back to ${step.lastElementChild?.textContent || `step ${number}`}` : `${step.lastElementChild?.textContent || `Step ${number}`}${number === visibleStep ? ', current step' : ''}`);
          const dot = step.querySelector('.fluff-bab-step-dot');
          if (dot) dot.textContent = number < visibleStep ? '✓' : String(number);
          if (number === 3 && !showAddOns) step.setAttribute('aria-label', 'Extras unavailable');
        });
      };

      const syncNavigation = () => {
        const reason = nextBlockReason();
        const count = state.activeBase ? groupTotal(state.activeBase) : 0;
        back.style.visibility = state.step === 1 ? 'hidden' : 'visible';
        back.disabled = state.transitioning;
        next.disabled = Boolean(reason || state.transitioning);
        nextHelp.textContent = reason;
        nextHelp.hidden = !reason;
        backLabel.textContent = state.step === 2 ? (state.returnToReview ? 'Review' : 'Change base') : 'Back';
        if (state.step === 1) nextLabel.textContent = state.activeBase ? `Build ${baseById(state.activeBase)?.name || ''}` : 'Choose a base';
        if (state.step === 2) nextLabel.textContent = count >= minimum ? `Continue with ${count}` : `Add ${Math.max(0, minimum - count)} more`;
        if (state.step === 3) nextLabel.textContent = totalAddOns() ? `Review with ${totalAddOns()} extras` : 'Skip to review';
        if (state.step === 4) nextLabel.textContent = 'Add to Cart';
        nextArrow.textContent = state.step === 4 ? '＋' : '→';
      };

      const renderImage = (item, className = '') => item.image
        ? `<img class="${className}" src="${escapeHtml(item.image)}" alt="" loading="lazy">`
        : `<span class="fluff-bab-image-placeholder ${className}" aria-hidden="true">✦</span>`;

      const renderFactors = (flavour) => {
        const factors = [['Fluff factor', flavour.factors?.fluff], ['Crunch factor', flavour.factors?.crunch], ['Nostalgia factor', flavour.factors?.nostalgia]].filter(([, value]) => Number(value) > 0);
        return factors.length ? `<div class="fluff-bab-detail-factors">${factors.map(([label, value]) => `<div class="fluff-bab-detail-factor"><span>${label}</span><strong>${Math.min(5, Number(value))}/5</strong></div>`).join('')}</div>` : '';
      };

      const renderDetail = (flavour) => {
        const detail = flavour.detailHtml
          ? `<div class="fluff-bab-detail-layout">${flavour.image ? `<img class="fluff-bab-detail-hero" src="${escapeHtml(flavour.image)}" alt="">` : ''}<div><h3 class="fluff-bab-detail-title">${escapeHtml(flavour.name)}</h3><div class="fluff-bab-detail-copy">${flavour.detailHtml}</div>${renderFactors(flavour)}</div></div>`
          : flavour.detailImage
            ? `<h3 class="visually-hidden">${escapeHtml(flavour.name)}</h3><img class="fluff-bab-detail-card" src="${escapeHtml(flavour.detailImage)}" alt="${escapeHtml(flavour.detailImageAlt || `${flavour.name} flavour details`)}">`
            : `<h3 class="fluff-bab-detail-title">${escapeHtml(flavour.name)}</h3><p>Details are coming soon.</p>`;
        body.innerHTML = `<div class="fluff-bab-detail"><button class="fluff-bab-detail-back" type="button" data-bab-detail-back>← Back to treats</button>${detail}</div>`;
        body.querySelector('[data-bab-detail-back]')?.focus();
      };

      const renderBaseScreen = () => {
        const cards = data.bases.map((base) => {
          const products = baseProducts(base.id);
          const selected = state.activeBase === base.id;
          const existing = groupTotal(base.id);
          const image = baseImage(base.id);
          return `<button class="fluff-bab-base-card ${selected ? 'is-selected' : ''}" style="--base-accent:${escapeHtml(base.accent)}" type="button" data-bab-base="${escapeHtml(base.id)}" aria-pressed="${selected}" ${products.length ? '' : 'disabled'}><span class="fluff-bab-base-image">${image ? `<img src="${escapeHtml(image)}" alt="">` : '<span aria-hidden="true">✦</span>'}</span><span class="fluff-bab-base-copy"><strong>${escapeHtml(base.name)}</strong><span>${escapeHtml(base.description)}</span>${existing ? `<small>${existing} treats already selected</small>` : ''}</span><span class="fluff-bab-base-action" aria-hidden="true">${selected ? '✓' : '→'}</span></button>`;
        }).join('');
        body.innerHTML = `<header><h3 class="fluff-bab-title">Choose your <em>marshmallow base</em></h3><p class="fluff-bab-hint">Start with one base and choose at least <strong>${minimum} treats.</strong> You can always add more.</p></header><div class="fluff-bab-rule" role="note"><span aria-hidden="true">☺</span><strong>${minimum} minimum · no maximum</strong></div><section class="fluff-bab-base-list" aria-label="Marshmallow bases">${cards}</section><p class="fluff-bab-multi-base">Want more than one base? Finish this group, then add another.</p>`;
      };

      const renderProduct = (flavour) => {
        const counts = groupCounts(state.activeBase);
        const count = Number(counts[flavour.id] || 0);
        const variant = selectedVariant(flavour);
        const available = Boolean(variant?.id && variant.available);
        const changed = state.lastCountChange?.id === flavour.id && state.lastCountChange?.kind === 'flavour';
        const direction = changed ? state.lastCountChange.direction : 0;
        const status = available ? `${escapeHtml(flavour.categoryName || 'Fluff Pop')} · ${money(variant.price)}` : `Unavailable in ${escapeHtml(state.popSize)}`;
        return `<article class="fluff-bab-product"><button class="fluff-bab-product-image-button" type="button" data-bab-detail="${escapeHtml(flavour.id)}" aria-label="Learn more about ${escapeHtml(flavour.name)}">${renderImage(flavour)}</button><div class="fluff-bab-product-copy"><strong>${escapeHtml(flavour.name)}</strong><small class="${available ? '' : 'is-unavailable'}">${status}</small>${flavour.detailHtml || flavour.detailImage ? `<button class="fluff-bab-learn" type="button" data-bab-detail="${escapeHtml(flavour.id)}">Learn more</button>` : ''}</div><span class="fluff-bab-counter"><button class="${direction < 0 ? 'is-just-pressed' : ''}" type="button" data-bab-flavour="${escapeHtml(flavour.id)}" data-change="-1" ${count ? '' : 'disabled'} aria-label="Remove one ${escapeHtml(flavour.name)}">−</button><span class="${changed ? 'is-counting' : ''}">${count}</span><button class="${direction > 0 ? 'is-just-pressed' : ''}" type="button" data-bab-flavour="${escapeHtml(flavour.id)}" data-change="1" ${available ? '' : 'disabled'} aria-label="Add one ${escapeHtml(flavour.name)}">+</button></span></article>`;
      };

      const renderTreatScreen = () => {
        const base = baseById(state.activeBase);
        if (!base) { state.step = 1; renderBaseScreen(); return; }
        const products = baseProducts(base.id);
        const count = groupTotal(base.id);
        const met = count >= minimum;
        const grouped = products.reduce((groups, product) => {
          const label = product.categoryGroup === 'specialty' ? 'Specialty treats' : 'Classic Fluff Pops';
          (groups[label] ||= []).push(product);
          return groups;
        }, {});
        const groups = Object.entries(grouped).map(([label, items]) => `<section class="fluff-bab-category-group"><h4>${escapeHtml(label)}</h4><div class="fluff-bab-products">${items.map(renderProduct).join('')}</div></section>`).join('');
        const hasSizedProducts = products.some((product) => product.variantMode === 'size');
        const sizeRow = hasSizedProducts ? `<div class="fluff-bab-size-row"><strong>Classic Pop size</strong><div class="fluff-bab-size-options">${data.popSizes.map((size) => `<button class="fluff-bab-size ${state.popSize === size.id ? 'is-selected' : ''}" type="button" data-bab-size="${size.id}" aria-pressed="${state.popSize === size.id}">${escapeHtml(size.name)} · ${escapeHtml(size.dimensions)}</button>`).join('')}</div></div>` : '';
        const image = baseImage(base.id);
        body.innerHTML = `<button class="fluff-bab-back-link" type="button" data-bab-change-base>← ${state.returnToReview ? 'Back to review' : 'Change base'}</button><header class="fluff-bab-selection-heading"><div><span class="fluff-bab-eyebrow">${escapeHtml(base.name)} base</span><h3 class="fluff-bab-title">Choose your treats</h3></div>${image ? `<img class="fluff-bab-selection-image" src="${escapeHtml(image)}" alt="">` : ''}</header><p class="fluff-bab-hint">Choose at least <strong>${minimum} ${escapeHtml(base.name)}</strong> treats. Add as many as you like.</p>${sizeRow}<section class="fluff-bab-threshold ${met ? 'is-met' : ''}" aria-live="polite"><div class="fluff-bab-threshold-copy"><span class="fluff-bab-threshold-icon">${met ? '✓' : count}</span><div><strong>${met ? `${count} selected · minimum met` : `${count} selected · ${minimum - count} more needed`}</strong><span>${met ? 'Keep adding, or continue when you’re ready.' : `The next step unlocks at ${minimum}.`}</span></div></div><div class="fluff-bab-threshold-track" aria-hidden="true"><span style="width:${Math.min(100, (count / minimum) * 100)}%"></span></div></section>${groups || '<p class="fluff-bab-empty">No compatible treats are available for this base right now.</p>'}`;
      };

      const renderExtrasScreen = () => {
        const products = data.addOns.map((addOn) => {
          const variant = selectedAddOnVariant(addOn);
          const available = Boolean(variant?.id && variant.available);
          const count = Number(state.addOnCounts[addOn.id] || 0);
          const addMinimum = Math.max(1, Number(addOn.minimum || 1));
          const changed = state.lastCountChange?.id === addOn.id && state.lastCountChange?.kind === 'add-on';
          const direction = changed ? state.lastCountChange.direction : 0;
          return `<article class="fluff-bab-product">${renderImage(addOn)}<div class="fluff-bab-product-copy"><strong>${escapeHtml(addOn.name)}</strong><small class="${available ? '' : 'is-unavailable'}">${available ? `${money(variant.price)}${addMinimum > 1 ? ` · minimum ${addMinimum}` : ''}` : 'Unavailable'}</small></div><span class="fluff-bab-counter"><button class="${direction < 0 ? 'is-just-pressed' : ''}" type="button" data-bab-add-on="${escapeHtml(addOn.id)}" data-change="-1" ${count ? '' : 'disabled'} aria-label="Remove one ${escapeHtml(addOn.name)}">−</button><span class="${changed ? 'is-counting' : ''}">${count}</span><button class="${direction > 0 ? 'is-just-pressed' : ''}" type="button" data-bab-add-on="${escapeHtml(addOn.id)}" data-change="1" ${available ? '' : 'disabled'} aria-label="Add one ${escapeHtml(addOn.name)}">+</button></span></article>`;
        }).join('');
        body.innerHTML = `<header><span class="fluff-bab-eyebrow">Totally optional</span><h3 class="fluff-bab-title">Make it extra special</h3><p class="fluff-bab-hint">Add minis and party favourites, or skip this step.</p></header><div class="fluff-bab-products">${products || '<p class="fluff-bab-empty">No extras are available right now.</p>'}</div>`;
      };

      const renderReviewScreen = () => {
        const groups = startedBases().map((base) => {
          const count = groupTotal(base.id);
          const image = baseImage(base.id);
          const names = data.flavours.filter((flavour) => groupCounts(base.id)[flavour.id]).map((flavour) => `${groupCounts(base.id)[flavour.id]} × ${escapeHtml(flavour.name)}`).join(', ');
          return `<article class="fluff-bab-review-group">${image ? `<img src="${escapeHtml(image)}" alt="">` : '<span class="fluff-bab-review-group__placeholder">✦</span>'}<div><h4>${escapeHtml(base.name)} base</h4><p>${count} treats · ${names}</p></div><button type="button" data-bab-edit-base="${escapeHtml(base.id)}">Edit</button></article>`;
        }).join('');
        body.innerHTML = `<header><span class="fluff-bab-eyebrow">Everything look delicious?</span><h3 class="fluff-bab-title">Review your order</h3></header><section class="fluff-bab-review-groups" aria-label="Selected base groups">${groups}</section><button class="fluff-bab-add-base" type="button" data-bab-add-base><span aria-hidden="true">＋</span> Add another base</button>${totalAddOns() ? `<div class="fluff-bab-extras-summary"><strong>Extras</strong><span>${totalAddOns()} selected</span></div>` : ''}<div class="fluff-bab-total"><span>Estimated total</span><strong>${money(totalPrice())}</strong></div>`;
      };

      const render = (direction = '') => {
        clearStepMotion();
        hideError();
        syncProgress();
        nav.hidden = Boolean(state.detailId);
        closeButton.hidden = Boolean(state.detailId);
        if (state.detailId) {
          const flavour = data.flavours.find((item) => item.id === state.detailId);
          if (flavour) { renderDetail(flavour); return; }
          state.detailId = null;
          nav.hidden = false;
          closeButton.hidden = false;
        }
        if (!data.flavours.length) body.innerHTML = '<h3 class="fluff-bab-title">Build a Box is temporarily unavailable</h3><p class="fluff-bab-hint">No eligible treats were found. Please check back soon.</p>';
        else if (state.step === 1) renderBaseScreen();
        else if (state.step === 2) renderTreatScreen();
        else if (state.step === 3) renderExtrasScreen();
        else renderReviewScreen();
        syncNavigation();
        if (direction) {
          body.classList.add(`fluff-bab-enter-${direction}`);
          stepMotionTimer = window.setTimeout(() => { body.classList.remove(`fluff-bab-enter-${direction}`); stepMotionTimer = 0; }, 460);
        }
        state.lastCountChange = null;
        card.scrollTop = 0;
      };

      const renderPreservingScroll = () => {
        const scrollTop = card.scrollTop;
        render();
        card.scrollTop = scrollTop;
      };

      const playPress = (button) => {
        if (!motionAllowed()) return;
        button.classList.remove('is-pressed');
        void button.offsetWidth;
        button.classList.add('is-pressed');
        window.setTimeout(() => button.classList.remove('is-pressed'), 450);
      };

      const changeStep = (nextStep, direction) => {
        if (state.transitioning) return;
        hideError();
        if (!motionAllowed()) { state.step = nextStep; render(); return; }
        state.transitioning = true;
        back.disabled = true;
        next.disabled = true;
        clearStepMotion();
        body.classList.add(`fluff-bab-leave-${direction}`);
        window.setTimeout(() => { state.step = nextStep; state.transitioning = false; render(direction); }, 185);
      };

      const reset = (options = {}) => {
        state.step = 1;
        state.activeBase = normaliseBase(options.base);
        state.groups = {};
        state.popSize = 'large';
        state.addOnCounts = {};
        state.detailId = null;
        state.detailScrollTop = 0;
        state.returnToReview = false;
        state.lastCountChange = null;
        state.transitioning = false;
        hideError();
        render();
      };

      const open = (options = {}) => {
        reset(options || {});
        document.querySelectorAll('dialog[open]').forEach((openDialog) => { if (openDialog !== dialog && typeof openDialog.close === 'function') openDialog.close(); });
        if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
        else if (!dialog.open) dialog.setAttribute('open', '');
        if (motionAllowed()) {
          clearOpeningMotion();
          void dialog.offsetWidth;
          dialog.classList.add('is-opening');
          openingMotionTimer = window.setTimeout(clearOpeningMotion, 1100);
        }
        return true;
      };

      const addToCart = async () => {
        if (!window.FluffCart?.addItems) {
          await Promise.race([
            new Promise((resolve) => document.addEventListener('fluff:cart-ready', resolve, { once: true })),
            new Promise((_, reject) => setTimeout(() => reject(new Error('The cart is still loading. Please try again.')), 5000)),
          ]);
        }
        if (!startedBases().length || startedBases().some((base) => groupTotal(base.id) < minimum)) throw new Error(`Each started base group requires at least ${minimum} treats.`);
        const items = [];
        const buildId = `Fluff Box ${Date.now()}`;
        startedBases().forEach((base) => {
          data.flavours.forEach((flavour) => {
            const quantity = Number(groupCounts(base.id)[flavour.id] || 0);
            if (!quantity) return;
            const variant = selectedVariant(flavour);
            if (!variant?.id || !variant.available) throw new Error(`${flavour.name} is not available in the selected size.`);
            items.push({ variantId: variant.id, quantity, properties: { 'Build a Box': buildId, 'Marshmallow base': base.name, 'Fluff Pop size': flavour.variantMode === 'size' ? state.popSize : 'One size' } });
          });
        });
        data.addOns.forEach((addOn) => {
          const quantity = Number(state.addOnCounts[addOn.id] || 0);
          if (!quantity) return;
          const variant = selectedAddOnVariant(addOn);
          if (!variant?.id || !variant.available) throw new Error(`${addOn.name} is no longer available.`);
          items.push({ variantId: variant.id, quantity, properties: { 'Build a Box': buildId, 'Build a Box add-on': 'Yes' } });
        });
        await window.FluffCart.addItems(items);
      };

      const returnFromDetail = () => {
        if (!state.detailId) return;
        const detailId = state.detailId;
        state.detailId = null;
        render();
        card.scrollTop = state.detailScrollTop;
        body.querySelector(`[data-bab-detail="${CSS.escape(detailId)}"]`)?.focus();
      };

      const navigateFromProgress = (targetStep) => {
        if (targetStep >= state.step || state.transitioning) return;
        if (targetStep === 3 && !showAddOns) return;
        if (targetStep === 2 && !state.activeBase) state.activeBase = startedBases()[0]?.id || data.bases[0]?.id || null;
        state.returnToReview = false;
        changeStep(targetStep, 'back');
      };

      dialog.querySelector('.fluff-bab-curtain--back')?.addEventListener('animationend', (event) => { if (event.animationName === 'fluffBabCurtainReveal') clearOpeningMotion(); });
      body.addEventListener('animationend', (event) => { if (event.target === body && ['fluffBabStepNext', 'fluffBabStepBack'].includes(event.animationName)) clearStepMotion(); });
      dialog.addEventListener('close', () => { clearOpeningMotion(); clearStepMotion(); });
      dialog.addEventListener('cancel', (event) => { if (state.detailId) { event.preventDefault(); returnFromDetail(); } });

      dialog.addEventListener('click', (event) => {
        const progressStep = event.target.closest?.('[data-bab-step]:not(:disabled)');
        if (progressStep) { navigateFromProgress(Number(progressStep.dataset.babStep)); return; }
        const detailBack = event.target.closest?.('[data-bab-detail-back]');
        if (detailBack) { returnFromDetail(); return; }
        const detailButton = event.target.closest?.('[data-bab-detail]');
        if (detailButton) { state.detailScrollTop = card.scrollTop; state.detailId = detailButton.dataset.babDetail; render(); return; }
        const baseButton = event.target.closest?.('[data-bab-base]');
        if (baseButton) { state.activeBase = baseButton.dataset.babBase; hideError(); render(); return; }
        const sizeButton = event.target.closest?.('[data-bab-size]');
        if (sizeButton) {
          if (state.popSize !== sizeButton.dataset.babSize) data.flavours.filter((flavour) => flavour.variantMode === 'size').forEach((flavour) => { Object.values(state.groups).forEach((counts) => { delete counts[flavour.id]; }); });
          state.popSize = sizeButton.dataset.babSize;
          renderPreservingScroll();
          return;
        }
        const flavourButton = event.target.closest?.('[data-bab-flavour]');
        if (flavourButton) {
          const id = flavourButton.dataset.babFlavour;
          const direction = Number(flavourButton.dataset.change);
          const counts = (state.groups[state.activeBase] ||= {});
          counts[id] = Math.max(0, Number(counts[id] || 0) + direction);
          if (!counts[id]) delete counts[id];
          state.lastCountChange = { kind: 'flavour', id, direction };
          renderPreservingScroll();
          const same = body.querySelector(`[data-bab-flavour="${CSS.escape(id)}"][data-change="${direction}"]`);
          const fallback = body.querySelector(`[data-bab-flavour="${CSS.escape(id)}"][data-change="${-direction}"]`);
          (same?.disabled ? fallback : same)?.focus({ preventScroll: true });
          return;
        }
        const addOnButton = event.target.closest?.('[data-bab-add-on]');
        if (addOnButton) {
          const id = addOnButton.dataset.babAddOn;
          const direction = Number(addOnButton.dataset.change);
          const addOn = data.addOns.find((item) => item.id === id);
          const addMinimum = Math.max(1, Number(addOn?.minimum || 1));
          const current = Number(state.addOnCounts[id] || 0);
          state.addOnCounts[id] = direction > 0 ? (current || addMinimum) + (current ? 1 : 0) : (current <= addMinimum ? 0 : current - 1);
          if (!state.addOnCounts[id]) delete state.addOnCounts[id];
          state.lastCountChange = { kind: 'add-on', id, direction };
          renderPreservingScroll();
          return;
        }
        const editButton = event.target.closest?.('[data-bab-edit-base]');
        if (editButton) { state.activeBase = editButton.dataset.babEditBase; state.returnToReview = true; changeStep(2, 'back'); return; }
        if (event.target.closest?.('[data-bab-add-base]')) { state.activeBase = null; state.returnToReview = true; changeStep(1, 'back'); return; }
        if (event.target.closest?.('[data-bab-change-base]')) {
          const target = state.returnToReview ? 4 : 1;
          if (state.returnToReview) state.returnToReview = false;
          changeStep(target, 'back');
          return;
        }
      });

      back.addEventListener('click', () => {
        playPress(back);
        if (state.step === 2) {
          const target = state.returnToReview ? 4 : 1;
          if (state.returnToReview) state.returnToReview = false;
          changeStep(target, 'back');
        }
        else if (state.step === 3) changeStep(2, 'back');
        else if (state.step === 4) changeStep(showAddOns ? 3 : 2, 'back');
      });

      next.addEventListener('click', async () => {
        const reason = nextBlockReason();
        if (reason) { showError(reason); return; }
        playPress(next);
        if (state.step === 1) { changeStep(2, 'next'); return; }
        if (state.step === 2) {
          const target = showAddOns ? 3 : 4;
          state.returnToReview = false;
          changeStep(target, 'next');
          return;
        }
        if (state.step === 3) { changeStep(4, 'next'); return; }
        next.disabled = true;
        nextLabel.textContent = 'Adding…';
        nextArrow.textContent = '';
        hideError();
        try {
          await addToCart();
          dialog.close();
          window.FluffTheme?.toast?.('Your custom Fluff Box was added to cart');
        } catch (cartError) {
          showError(cartError.message || 'We could not add this box. Please try again.');
        } finally {
          next.disabled = false;
          nextLabel.textContent = 'Add to Cart';
          nextArrow.textContent = '＋';
        }
      });

      window.FluffBuildBox = { version: 'base-first-v3', open, reset };
      reset();
      return window.FluffBuildBox;
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
    else setup();
    document.addEventListener('shopify:section:load', setup);
    document.addEventListener('fluff:open-build-box', (event) => setup()?.open(event.detail || {}));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fluff-globals"] && !Shopify.designMode) return;
  try {
    /* ============================================================
     FLUFFMALLOWS — site-wide behaviour (loaded on every page)

     Four jobs:
       1. the help menu behind the 💬 icon in the header
       2. opening "Build a Box" from any button, anywhere
       3. the image pop-up for gallery photos
       4. opening the cart drawer after something is added

     Kept separate from fluff-shared.liquid because that one only
     loads where a Fluff section is used; this loads everywhere.
     ============================================================ */
  (() => {
    // Create the shared namespace here as well as in the nearby inline
    // script. Shopify may schedule snippet JavaScript in a different order,
    // and this keeps initialization from stopping before click handlers exist.
    window.FluffTheme = window.FluffTheme || {};

    // Don't set up twice if this snippet is rendered more than once.
    if (window.FluffGlobalsReady) return;
    window.FluffGlobalsReady = true;

    // Short helpers: q = find one element, qa = find all of them.
    const q = (sel, root = document) => root.querySelector(sel);
    const qa = (sel, root = document) => [...root.querySelectorAll(sel)];

    // Small message pill at the bottom of the screen, ~3 seconds.
    const toast = (message) => {
      let el = q('.fluff-toast');
      if (!el) {
        el = document.createElement('div');
        el.className = 'fluff-toast';
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        document.body.appendChild(el);
      }
      el.textContent = message;
      el.classList.add('is-visible');
      clearTimeout(el.hideTimer);
      el.hideTimer = setTimeout(() => el.classList.remove('is-visible'), 2800);
    };
    window.FluffTheme.toast = toast;

    /* ---------- 1. THE HELP MENU (💬 header icon) ----------
       A small menu that drops down from the header icon. Most of its
       links open a pre-addressed email; "Flavour assistant" jumps to
       the flavour map instead. Any button marked data-fluff-help opens
       it, so the footer can use it too. */
    const helpMenu = q('#fluff-help-menu');
    if (helpMenu) {
      helpMenu.hidden = false;

      // Move the menu so it hangs just under whichever button was used.
      const place = (btn) => {
        const r = btn.getBoundingClientRect();
        helpMenu.style.right = `${Math.max(8, innerWidth - r.right - 4)}px`;
        helpMenu.style.top = `${r.bottom + 14}px`;
      };

      document.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-fluff-help]');
        if (btn) {
          event.preventDefault();
          place(btn);
          helpMenu.classList.toggle('is-open');
          return;
        }
        // A click anywhere else closes it.
        if (!helpMenu.contains(event.target)) helpMenu.classList.remove('is-open');
      });

      // Escape closes it too.
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') helpMenu.classList.remove('is-open');
      });

      helpMenu.addEventListener('click', (event) => {
        const link = event.target.closest('a');
        if (!link) return;
        helpMenu.classList.remove('is-open');
        // If there's a flavour map on this page, scroll to it rather
        // than navigating away to the flavours page.
        const map = q('[data-fluff-map]');
        if (link.hasAttribute('data-fluff-help-link') && map) {
          event.preventDefault();
          map.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    /* ---------- 2. SITE-WIDE POP-UPS AND "BUILD A BOX" ----------
       Generic Fluff actions (quote, wholesale and named image pop-ups)
       use data-fluff-open="ID". Keep that wiring global so hero buttons
       do not depend on a section-scoped script having initialized first. */
    document.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element
        ? event.target.closest('[data-fluff-open]')
        : null;
      if (!trigger) return;

      const target = trigger.dataset.fluffOpen;
      const dialog = document.getElementById(target)
        || [...document.querySelectorAll('[data-fluff-dialog]')]
          .find((candidate) => candidate.dataset.fluffDialog === target);
      if (!dialog) return;

      event.preventDefault();
      forceOpenDialog(dialog);
    });

    /* "BUILD A BOX" FROM ANY BUTTON
       Mark any button or link with data-fluff-build-box, or point a
       link at #build-a-box, and it opens the box builder pop-up.

       The full four-step builder is rendered globally, so this works on
       every template without requiring a box-builder page section. */
    function forceOpenDialog(dialog) {
      if (!dialog) return false;

      // A second open modal makes showModal throw. Close it first so a
      // Build a Box click always wins, then use the open attribute as a
      // fallback for browsers or theme scripts that interfere with dialog.
      qa('dialog[open]').forEach((openDialog) => {
        if (openDialog !== dialog && typeof openDialog.close === 'function') openDialog.close();
      });
      try {
        if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
      } catch (error) {
        dialog.setAttribute('open', '');
      }
      if (!dialog.open) dialog.setAttribute('open', '');
      return true;
    }

    const openBuildABox = (options = {}) => {
      if (window.FluffBuildBox?.open) return window.FluffBuildBox.open(options);

      // If Shopify scheduled the builder's script after this one, ask it to
      // initialize now. The direct dialog fallback still guarantees a pop-up.
      document.dispatchEvent(new CustomEvent('fluff:open-build-box', { detail: options }));
      if (window.FluffBuildBox?.open) return true;
      return forceOpenDialog(q('#FluffGlobalBuildBox'));
    };
    window.FluffTheme.openBuildABox = openBuildABox;

    document.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element
        ? event.target.closest('[data-fluff-build-box], a[href$="#build-a-box"], a[href$="#FluffBuilder"]')
        : null;
      if (!trigger) return;
      event.preventDefault();
      openBuildABox({ base: trigger.dataset.fluffBuildBoxBase || null });
    });

    // Global builders can appear on templates that do not load any other
    // Fluff section, so their close button and backdrop are handled here too.
    document.addEventListener('click', (event) => {
      const close = event.target instanceof Element ? event.target.closest('[data-fluff-close]') : null;
      const dialog = close?.closest('dialog');
      if (dialog?.open) dialog.close();
      if (event.target instanceof HTMLDialogElement && event.target.open) event.target.close();
    });

    /* ---------- 3. IMAGE POP-UP (gallery photos) ----------
       Clicking anything marked data-fluff-lightbox shows that photo
       big, in the middle of the screen, with its caption underneath.
       The attribute holds the large version of the image. */
    const lightbox = q('#fluff-lightbox');
    if (lightbox) {
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-fluff-lightbox]');
        if (!trigger) return;
        event.preventDefault();
        const img = trigger.tagName === 'IMG' ? trigger : q('img', trigger);
        if (!img) return;
        const target = q('[data-fluff-lightbox-image]', lightbox);
        const caption = q('[data-fluff-lightbox-caption]', lightbox);
        // Prefer the big version; fall back to whatever is on screen.
        target.src = trigger.dataset.fluffLightbox || img.currentSrc || img.src;
        target.alt = img.alt || '';
        const text = trigger.dataset.fluffCaption || '';
        caption.textContent = text;
        caption.hidden = !text;
        if (typeof lightbox.showModal === 'function') lightbox.showModal();
      });
    }

    /* ---------- 4. AFTER ADDING TO CART ----------
       When something is added, slide the cart drawer open and give the
       newest line a little pop, the way the prototype does. */

    // Briefly animates the top line item in the drawer.
    const flashNewLineItem = () => {
      requestAnimationFrame(() => {
        const item = q('#cart-drawer .cart-item');
        if (!item) return;
        item.classList.add('fluff-just-added');
        setTimeout(() => item.classList.remove('fluff-just-added'), 700);
      });
    };

    // Themes open their cart drawer in different ways, so try the
    // usual ones in turn and, failing all of them, just click the
    // cart button in the header.
    const openCartDrawer = () => {
      const drawer = document.getElementById('cart-drawer');
      if (!drawer) return;
      if (typeof drawer.showDialog === 'function') drawer.showDialog();
      else if (typeof drawer.open === 'function') drawer.open();
      else {
        const dialog = drawer.querySelector('dialog');
        if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
        else q('[data-testid="cart-drawer-trigger"]')?.click();
      }
    };

    // Small delay so the theme has finished refreshing the drawer's
    // contents before we open it and animate the new line.
    document.addEventListener('fluff:cart-added', () => {
      setTimeout(() => { openCartDrawer(); flashNewLineItem(); }, 60);
    });

    /* Reveal-on-scroll for stock theme sections is pure CSS — add the
       class `fluff-reveal` to any element to give it the rise-in. */
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fluff-shared"] && !Shopify.designMode) return;
  try {
    /* ============================================================
     FLUFF MALLOWS — shared behaviour for every Fluff section.

     Everything lives in one self-running function so nothing leaks
     into the global scope. It powers five things:
       1. the little "Added to your cart" message (toast)
       2. the flavour map: zoom, scroll and parallax
       3. the on-page box builder
       4. the step-by-step box builder dialog
       5. adding items to the real Shopify cart

     This snippet is rendered by several sections, but Shopify only
     includes the code once — and the guard on the first line stops
     it setting itself up twice.
     ============================================================ */
  (() => {
    // Already set up on this page? Then stop here.
    if (window.FluffMallowsComponents) return;

    // Short helpers: q = find one element, qa = find all of them.
    const q = (selector, root = document) => root.querySelector(selector);
    const qa = (selector, root = document) => [...root.querySelectorAll(selector)];

    // Shopify gives prices in cents (4200). Turn that into "CA$42.00".
    const money = (cents, currency = 'CAD') => new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);

    // Shows a small pill at the bottom of the screen for ~3 seconds.
    // Re-uses the same element each time instead of stacking them up.
    const toast = (message) => {
      let el = q('.fm-toast');
      if (!el) {
        el = document.createElement('div');
        el.className = 'fm-toast';
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        document.body.appendChild(el);
      }
      el.textContent = message;
      el.classList.add('is-visible');
      window.clearTimeout(el.hideTimer);
      el.hideTimer = window.setTimeout(() => el.classList.remove('is-visible'), 2800);
    };
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const motionSelector = '[data-fluff-motion="true"][data-fluff-reveal], [data-fluff-motion="true"] [data-fluff-reveal]';
    const motionObserver = !reducedMotion && 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('fluff-motion-visible');
            motionObserver.unobserve(entry.target);
          });
        }, { threshold: .12, rootMargin: '0px 0px -7% 0px' })
      : null;

    const reveal = (root = document) => {
      document.documentElement.classList.add('fluff-motion-ready');
      const targets = qa(motionSelector, root);
      if (root instanceof Element && root.matches(motionSelector)) targets.unshift(root);
      targets.forEach((target, index) => {
        target.style.setProperty('--fluff-motion-delay', `${Math.min(index * .08, .4)}s`);
        if (motionObserver) motionObserver.observe(target);
        else target.classList.add('fluff-motion-visible');
      });
    };

    /* ---------- THE FLAVOUR MAP ----------
       Sets up each flavour map's centred mobile viewport and zoom
       controls. Its background and Fluff Pops share one canvas, so their
       visual relationship never changes. */
    const setupMap = (root = document) => {
      qa('[data-fluff-map]:not([data-fluff-ready])', root).forEach((map) => {
        map.dataset.fluffReady = 'true';

        // The visible window, the part that scrolls, and the unified
        // background-and-pop canvas.
        const stage = q('.fm-map-stage', map);
        const scroller = q('.fm-map-scroller', map);
        const world = q('.fm-map-world', map);
        if (!stage || !scroller || !world) return;

        /* ---- ZOOM ----
           Zoom is just a number stored in the CSS variable --fm-zoom.
           1 = whole map visible, 3 = three times bigger. The CSS grows
           the map to match, which makes the area scrollable. */
        const startZoom = Number(getComputedStyle(map).getPropertyValue('--fm-zoom')) || 1;
        let zoom = startZoom;
        const MIN = 1;  // never smaller than "whole map fits"
        const MAX = 3;  // never more than 3x
        const isMobileMap = () => matchMedia('(max-width: 680px)').matches;
        const centredScrollLeft = () => Math.max(0, (scroller.scrollWidth - scroller.clientWidth) / 2);

        // Phones open on the centre of the larger canvas, with room to
        // swipe in either direction instead of seeing a compressed map.
        requestAnimationFrame(() => {
          if (isMobileMap()) scroller.scrollLeft = centredScrollLeft();
        });

        // Changes the zoom level, then re-scrolls so the spot the visitor
        // was looking at (the centre, or wherever they pointed) stays put
        // instead of the map jumping away under them.
        const applyZoom = (next, focal) => {
          const previous = zoom;
          zoom = Math.min(MAX, Math.max(MIN, Number(next.toFixed(2))));
          if (zoom === previous) return;
          const rect = scroller.getBoundingClientRect();
          // Where that spot currently sits inside the whole map.
          const cx = (focal ? focal.x - rect.left : rect.width / 2) + scroller.scrollLeft;
          const cy = (focal ? focal.y - rect.top : rect.height / 2) + scroller.scrollTop;
          const scale = zoom / previous;
          map.style.setProperty('--fm-zoom', String(zoom));
          // Wait one frame for the CSS to resize, then scroll to match.
          requestAnimationFrame(() => {
            scroller.scrollLeft = cx * scale - (focal ? focal.x - rect.left : rect.width / 2);
            scroller.scrollTop = cy * scale - (focal ? focal.y - rect.top : rect.height / 2);
          });
        };

        // The + / Fit / − buttons sitting on the map.
        map.addEventListener('click', (event) => {
          const button = event.target.closest('[data-map-zoom]');
          if (!button) return;
          const action = button.dataset.mapZoom;
          if (action === 'in') applyZoom(zoom + 0.25);
          if (action === 'out') applyZoom(zoom - 0.25);
          if (action === 'reset') {
            zoom = MIN;
            map.style.setProperty('--fm-zoom', String(MIN));
            requestAnimationFrame(() => {
              scroller.scrollTo({ left: isMobileMap() ? centredScrollLeft() : 0, top: 0, behavior: 'smooth' });
            });
          }
        });
        // Ctrl/⌘ + scroll wheel, and pinch-zoom on a trackpad, also zoom.
        // (Browsers report a pinch as a wheel event with ctrlKey set.)
        scroller.addEventListener('wheel', (event) => {
          if (!event.ctrlKey && !event.metaKey) return;
          event.preventDefault(); // stop the browser zooming the whole page
          applyZoom(zoom + (event.deltaY < 0 ? 0.2 : -0.2), { x: event.clientX, y: event.clientY });
        }, { passive: false });

      });
    };
    /* ---------- THE ON-PAGE BOX BUILDER ----------
       The "Build Your Box" section: pick a base, pick a box size, then
       tap flavours to fill the box picture on the right.

       The section's Liquid writes its bases, sizes and flavours into a
       hidden JSON block; this reads that, keeps track of what the
       shopper has chosen, and redraws the screen after every tap. */
    const setupBuilder = (root = document) => {
      qa('[data-fluff-builder]:not([data-fluff-ready])', root).forEach((section) => {
        section.dataset.fluffReady = 'true';

        // Read the choices the Theme Editor set up for this section.
        const dataEl = q('[data-fluff-builder-data]', section);
        if (!dataEl) return;
        let data;
        try { data = JSON.parse(dataEl.textContent); } catch { return; }
        if (!data.sizes.length || !data.bases.length) return;

        // What the shopper has chosen so far. "slots" is simply a list
        // of flavour ids, one entry per pop in the box.
        const state = { base: data.bases[0].name, size: data.sizes[0].count, slots: [] };

        // Turns that list into a tally, e.g. { smores: 3, cookie: 2 }.
        const counts = () => state.slots.reduce((all, id) => ({ ...all, [id]: (all[id] || 0) + 1 }), {});
        const activeSize = () => data.sizes.find((size) => size.count === state.size);

        // Redraws everything from `state`: which buttons look selected,
        // the flavour list, the pops in the box, the tally, the progress
        // bar, and whether Add to cart is allowed yet.
        const render = () => {
          qa('[data-builder-base]', section).forEach((button) => {
            const selected = button.dataset.builderBase === state.base;
            button.classList.toggle('is-selected', selected);
            button.setAttribute('aria-pressed', String(selected));
          });
          qa('[data-builder-size]', section).forEach((button) => {
            const selected = Number(button.dataset.builderSize) === state.size;
            button.classList.toggle('is-selected', selected);
            button.setAttribute('aria-pressed', String(selected));
          });
          const tally = counts();

          // Only show flavours made on the chosen base — a box can't
          // mix vanilla and strawberry marshmallow.
          const flavours = data.flavours.filter((flavour) => flavour.base === state.base);
          q('[data-builder-flavours]', section).innerHTML = flavours.map((flavour) => `<button type="button" class="fm-flavour ${tally[flavour.id] ? 'is-selected' : ''}" data-builder-flavour="${flavour.id}" aria-label="Add ${flavour.name}">${tally[flavour.id] ? `<b class="fm-flavour-count">×${tally[flavour.id]}</b>` : ''}${flavour.image ? `<img src="${flavour.image}" alt="">` : ''}<span>${flavour.name}</span></button>`).join('');

          const size = activeSize();

          // Lay the box picture out in a sensible grid for its size:
          // 6 pops = 3 across, 12 = 4 across, 24 = 6, 48 = 8.
          const columns = state.size <= 6 ? 3 : state.size <= 12 ? 4 : state.size <= 24 ? 6 : 8;
          const slots = q('[data-builder-slots]', section);
          slots.style.gridTemplateColumns = `repeat(${columns}, 1fr)`;
          // Each chosen pop is drawn in the box and can be clicked to
          // remove it. Uses the wrapped photo where one was supplied.
          slots.innerHTML = state.slots.map((id) => {
            const flavour = data.flavours.find((item) => item.id === id);
            const image = flavour.wrap || flavour.image;
            return `<button type="button" class="fm-box-slot" data-builder-remove="${id}" aria-label="Remove one ${flavour.name}">${image ? `<img src="${image}" alt="${flavour.name}">` : flavour.name}</button>`;
          }).join('');

          // The "3 × S'mores Please" list under the box.
          q('[data-builder-summary]', section).innerHTML = data.flavours.filter((flavour) => tally[flavour.id]).map((flavour) => `<div class="fm-summary-item">${flavour.wrap || flavour.image ? `<img src="${flavour.wrap || flavour.image}" alt="">` : ''}<strong>${tally[flavour.id]}×</strong><span>${flavour.name}</span></div>`).join('');

          // Progress bar. Kept at 14% minimum so the "0/6" label still fits.
          const percent = Math.round(state.slots.length / state.size * 100);
          const bar = q('[data-builder-progress]', section);
          bar.style.width = `${Math.max(percent, 14)}%`;
          bar.textContent = `${state.slots.length}/${state.size}`;

          // "Choose 2 more Fluff Pops" or "Box complete — CA$36.00".
          q('[data-builder-hint]', section).textContent = state.slots.length === state.size ? `Box complete — ${money(size.price, data.currency)}` : `Choose ${state.size - state.slots.length} more Fluff Pop${state.size - state.slots.length === 1 ? '' : 's'}`;

          // Only allow Add to cart on a full box of an in-stock size.
          q('[data-builder-add]', section).disabled = state.slots.length !== state.size || !size.available;
        };

        // One click handler for the whole section. It works out which
        // kind of control was clicked, updates `state`, and redraws.
        section.addEventListener('click', async (event) => {
          // Changing base empties the box, since flavours can't carry over.
          const base = event.target.closest('[data-builder-base]');
          if (base) { if (state.base !== base.dataset.builderBase) { state.base = base.dataset.builderBase; state.slots = []; } render(); return; }

          // Changing size keeps what fits and drops the overflow.
          const size = event.target.closest('[data-builder-size]');
          if (size) { state.size = Number(size.dataset.builderSize); state.slots = state.slots.slice(0, state.size); render(); return; }

          // Clicking a pop in the box removes one of that flavour.
          const remove = event.target.closest('[data-builder-remove]');
          if (remove) { const index = state.slots.lastIndexOf(remove.dataset.builderRemove); if (index > -1) state.slots.splice(index, 1); render(); return; }

          // Clicking a flavour card adds one, until the box is full.
          const flavour = event.target.closest('[data-builder-flavour]');
          if (flavour) { if (state.slots.length < state.size) state.slots.push(flavour.dataset.builderFlavour); render(); return; }

          // Anything left is the Add to cart button.
          const add = event.target.closest('[data-builder-add]');
          if (!add) return;
          const sizeData = activeSize();
          const tally = counts();
          // The chosen base and flavours travel with the order as
          // line-item properties, so they show on the order in Shopify.
          const selection = data.flavours.filter((item) => tally[item.id]).map((item) => `${tally[item.id]}× ${item.name}`).join(', ');
          add.disabled = true; // stop double-clicks while it's saving
          try {
            await addCartItem(sizeData.variantId, 1, { 'Marshmallow base': state.base, 'Flavours': selection });
            state.slots = []; // empty the box, ready for another
            render();
          } catch (error) { toast(error.message || data.error); render(); }
        });
        render(); // first paint
      });
    };

    /* ---------- THE STEP-BY-STEP BUILDER DIALOG ----------
       The pop-up version of the same thing, walking through four steps:
       1 pick a size → 2 pick a base → 3 pick flavours → 4 review.

       It borrows the flavour/size/base data from the builder section on
       the page (`data-source` points at it) so there's only one list to
       keep up to date in the Theme Editor. */
    const setupWizard = (root = document) => {
      qa('[data-fluff-wizard]:not([data-fluff-ready])', root).forEach((dialog) => {
        dialog.dataset.fluffReady = 'true';
        const source = document.getElementById(dialog.dataset.source);
        const dataEl = source && q('[data-fluff-builder-data]', source);
        if (!dataEl) return;
        let data;
        try { data = JSON.parse(dataEl.textContent); } catch { return; }

        // Which step we're on and what's been picked so far.
        const state = { step: 1, size: null, base: null, counts: {} };
        const total = () => Object.values(state.counts).reduce((sum, count) => sum + count, 0);
        const selectedSize = () => data.sizes.find((item) => item.count === state.size);

        // Draws the current step into the dialog and sets the
        // Back/Next buttons appropriately.
        const render = () => {
          // Highlight the numbered dot for the current step.
          qa('[data-wizard-dot]', dialog).forEach((dot) => dot.classList.toggle('is-active', Number(dot.dataset.wizardDot) === state.step));
          const body = q('[data-wizard-body]', dialog);

          // Step 1 — the box sizes with their prices.
          if (state.step === 1) {
            body.innerHTML = `<h2 class="fm-dialog-title">Choose your box size</h2><div class="fm-choices">` + data.sizes.map((size) => `<button type="button" class="fm-choice ` + (size.count === state.size ? 'is-selected' : '') + `" data-wizard-size="` + size.count + `">` + size.label + `<small>` + money(size.price, data.currency) + `</small></button>`).join('') + `</div>`;
          }
          // Step 2 — the marshmallow bases.
          if (state.step === 2) {
            body.innerHTML = `<h2 class="fm-dialog-title">Choose a marshmallow base</h2><div class="fm-choices">` + data.bases.map((base) => `<button type="button" class="fm-choice ` + (base.name === state.base ? 'is-selected' : '') + `" data-wizard-base="` + base.name + `">` + base.name + `</button>`).join('') + `</div>`;
          }

          // Step 3 — a − / count / + row per flavour on the chosen base.
          // The + buttons switch off once the box is full.
          if (state.step === 3) {
            const remaining = state.size - total();
            const flavours = data.flavours.filter((flavour) => flavour.base === state.base);
            body.innerHTML = `<h2 class="fm-dialog-title">Select your flavours</h2><p class="fm-hint">` + (remaining ? `Choose ` + remaining + ` more Fluff Pop` + (remaining === 1 ? '' : 's') : 'Your box is full!') + `</p><div class="fm-wizard-flavours">` + flavours.map((flavour) => `<div class="fm-wizard-row">` + (flavour.image ? `<img src="` + flavour.image + `" alt="">` : '<span></span>') + `<strong>` + flavour.name + `</strong><span class="fm-wizard-controls"><button type="button" data-wizard-flavour="` + flavour.id + `" data-change="-1" ` + (state.counts[flavour.id] ? '' : 'disabled') + ` aria-label="Remove one">−</button><b>` + (state.counts[flavour.id] || 0) + `</b><button type="button" data-wizard-flavour="` + flavour.id + `" data-change="1" ` + (remaining ? '' : 'disabled') + ` aria-label="Add one">+</button></span></div>`).join('') + `</div>`;
          }
          // Step 4 — a summary of the box before it goes in the cart.
          if (state.step === 4) {
            const chosen = data.flavours.filter((flavour) => state.counts[flavour.id]).map((flavour) => `<li>` + state.counts[flavour.id] + `× ` + flavour.name + `</li>`).join('');
            const size = selectedSize();
            body.innerHTML = `<h2 class="fm-dialog-title">Review your Fluff Box</h2><p><strong>Box of ` + state.size + `</strong> — ` + state.base + ` base</p><ul>` + chosen + `</ul><p class="fm-heading fm-heading--medium">` + money(size.price, data.currency) + `</p>`;
          }
          // Hide Back on the first step, and don't let anyone move on
          // until the current step has actually been answered.
          const back = q('[data-wizard-back]', dialog);
          const next = q('[data-wizard-next]', dialog);
          back.style.visibility = state.step === 1 ? 'hidden' : 'visible';
          next.textContent = state.step === 4 ? 'Add to cart' : 'Next';
          next.disabled = (state.step === 1 && !state.size) || (state.step === 2 && !state.base) || (state.step === 3 && total() !== state.size);
        };

        // Handles taps on the choices inside the dialog. Changing the
        // size or base clears the flavours, because they may no longer fit.
        dialog.addEventListener('click', async (event) => {
          const size = event.target.closest('[data-wizard-size]');
          if (size) { state.size = Number(size.dataset.wizardSize); state.counts = {}; render(); return; }
          const base = event.target.closest('[data-wizard-base]');
          if (base) { state.base = base.dataset.wizardBase; state.counts = {}; render(); return; }

          // The − and + buttons; count never goes below zero.
          const flavour = event.target.closest('[data-wizard-flavour]');
          if (flavour) {
            const id = flavour.dataset.wizardFlavour;
            state.counts[id] = Math.max(0, (state.counts[id] || 0) + Number(flavour.dataset.change));
            if (!state.counts[id]) delete state.counts[id];
            render();
          }
        });
        // Back button.
        q('[data-wizard-back]', dialog).addEventListener('click', () => { if (state.step > 1) { state.step -= 1; render(); } });

        // Next button — on the last step this is the Add to cart action,
        // after which the dialog closes and resets for next time.
        q('[data-wizard-next]', dialog).addEventListener('click', async (event) => {
          if (state.step < 4) { state.step += 1; render(); return; }
          const size = selectedSize();
          const selection = data.flavours.filter((flavour) => state.counts[flavour.id]).map((flavour) => `${state.counts[flavour.id]}× ${flavour.name}`).join(', ');
          event.currentTarget.disabled = true;
          try {
            await addCartItem(size.variantId, 1, { 'Marshmallow base': state.base, 'Flavours': selection });
            dialog.close();
            state.step = 1; state.size = null; state.base = null; state.counts = {}; render();
          } catch (error) { toast(error.message || data.error); render(); }
        });
        render();
      });
    };

    /* ---------- ADDING TO THE SHOPIFY CART ----------
       Hands the item to fluff-cart.js. That module posts to Shopify and
       emits Horizon's native cart event with fresh drawer HTML, so the
       badge, items and totals update without a page refresh. `properties`
       is where custom box details ride along. */
    const addCartItem = async (variantId, quantity = 1, properties = {}) => {
      if (!variantId) throw new Error('Choose a Shopify product in the Theme Editor first.');

      // fluff-cart.js imports Horizon's native event classes. Wait briefly if
      // its module is still loading, then use its asynchronous cart bridge.
      // The timeout turns a failed module load into a readable error instead
      // of leaving the Add button spinning forever.
      if (!window.FluffCart?.addItem) {
        await Promise.race([
          new Promise((resolve) => document.addEventListener('fluff:cart-ready', resolve, { once: true })),
          new Promise((_, reject) => setTimeout(() => reject(new Error('The cart is still loading. Please try again.')), 5000)),
        ]);
      }
      const result = await window.FluffCart.addItem(variantId, quantity, properties);
      toast('Added to your cart');
      return result;
    };

    // Runs all the setup routines. Called on page load, and again when
    // the Theme Editor re-renders a section.
    const setup = (root = document) => { reveal(root); setupMap(root); setupBuilder(root); setupWizard(root); };

    /* ---------- SHARED CLICK HANDLERS ----------
       These listen on the whole page, so they keep working for markup
       added later (Theme Editor edits, re-rendered sections):
         data-fluff-open="ID"  → open that pop-up
         data-fluff-close      → close the pop-up you're inside
         data-fluff-add="ID"   → add that product to the cart */
    document.addEventListener('click', async (event) => {
      const open = event.target.closest('[data-fluff-open]');
      if (open) {
        const dialog = document.getElementById(open.dataset.fluffOpen) || q(`[data-fluff-dialog="${open.dataset.fluffOpen}"]`);
        if (dialog?.showModal && !dialog.open) dialog.showModal();
      }
      const close = event.target.closest('[data-fluff-close]');
      if (close) close.closest('dialog')?.close();
      const add = event.target.closest('[data-fluff-add]');
      if (add) {
        add.disabled = true; // guard against double taps
        try { await addCartItem(add.dataset.fluffAdd, Number(add.dataset.quantity || 1)); add.closest('dialog')?.close(); } catch (error) { toast(error.message); }
        add.disabled = false;
      }
    });

    /* The − / + quantity steppers in the order pop-ups. Updates the
       number shown, the running price, and the quantity the Add to
       cart button will send. Never goes below 1. */
    document.addEventListener('click', (event) => {
      const step = event.target.closest('[data-qty-step]');
      if (!step) return;
      const wrap = step.closest('[data-fluff-qty]');
      const card = step.closest('.fm-dialog-card') || document;
      const valueEl = q('[data-qty-value]', wrap);
      const next = Math.max(1, Number(valueEl.textContent || 1) + Number(step.dataset.qtyStep));
      valueEl.textContent = String(next);
      const addButton = q('[data-fluff-add]', card);
      if (addButton) addButton.dataset.quantity = String(next);
      const priceEl = q('[data-qty-price]', card);
      if (priceEl) {
        const unit = Number(priceEl.dataset.unitPrice || 0);
        const currency = window.Shopify?.currency?.active || 'CAD';
        if (unit) priceEl.textContent = money(unit * next, currency);
      }
    });

    // Clicking the dark area around a pop-up closes it. (A click that
    // lands on the <dialog> itself, rather than the white card inside,
    // means the shopper clicked the backdrop.)
    document.addEventListener('click', (event) => {
      if (event.target.tagName === 'DIALOG') event.target.close();
    });

    // Set everything up when the page loads, and again whenever the
    // Theme Editor reloads a section while someone is editing.
    // Snippet bundles can execute before or after DOMContentLoaded depending
    // on Shopify's asset order. Handle both so the wizard is always wired.
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
    else setup();
    document.addEventListener('shopify:section:load', (event) => setup(event.target));

    // Expose a couple of helpers for other scripts (and for debugging).
    window.FluffMallowsComponents = { setup, addCartItem };
  })();
  } catch(e) { console.error(e); }
})();

})();
